.grid-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    margin-top: 16px;
}

.account-buttons {
    width: 350px;
}

.account-buttons button {
    width: 100%;
}
